const onboarding = {
  languageTitle: 'Izberite jezik',
  languageDescription: 'Izberite jezik aplikacije.',
  welcomeTitle: 'Dobrodošli v VoiceFill Medical',
  welcomeDescription:
    'Poenostavite pripravljanje izvidov z umetno inteligenco.',
  feature1Title: 'Glasovno snemanje',
  feature1Desc: 'Varno snemajte svoje izvide.',
  feature2Title: 'Prepisovanje z umetno inteligenco',
  feature2Desc:
    'Napredna umetna inteligenca pretvori govor v strukturirano besedilo.',
  feature3Title: 'Varnost in zasebnost',
  feature3Desc: 'Vaši podatki so šifrirani in zaščiteni.',
};

export default onboarding;
